import 'flickity/dist/flickity.css';
import Flickity from 'flickity';

class BoxCarousel {

    constructor(element) {
        console.log('BoxCarousel.constructor', element);
        this.element = element;
        //this.section = this.element.closest('section.colored-bg-carousel-container');
        
        this.section = this.element.parentElement.parentElement.parentElement;
        this.sectionBackground = document.createElement('div');

        /* does not work in IE11 */
        //this.sectionBackground.classList.add('colored-bg', 'colored-bg-carousel');
        this.sectionBackground.classList.add('colored-bg');
        this.sectionBackground.classList.add('colored-bg-carousel');
        this.section.appendChild(this.sectionBackground);

        let that = this;
        this.slides = this.element.getElementsByClassName('slides')[0];
        this.slider = new Flickity(this.slides, {
            selectedAttraction: 0.2,
            friction: 0.8,
            adaptiveHeight: false,
            on: {
                ready: function () {
                    console.log('Flickity is ready');
                    that.onSliderReady();
                }
            }
        });
    }

    destroy() {
        console.log('BoxCarousel.destroy', this.element);
        this.sectionBackground.parentNode.removeChild(this.sectionBackground);
        this.slider.destroy();
        window.removeEventListener('resize', this.onResize.bind(this));
    }

    updateBackground() {
        console.log('*** BoxCarousel.updateBackground', this.section.offsetHeight);
        let imageContainer = this.element.getElementsByClassName('image-container')[0];
        console.log('*** *** this.imageContainer', imageContainer.getBoundingClientRect().top - this.section.getBoundingClientRect().top, imageContainer.getBoundingClientRect().bottom, imageContainer.offsetHeight, imageContainer.getElementsByClassName('name-position-container')[0].offsetHeight/2);
        var backgroundHeight = (imageContainer.getBoundingClientRect().top - this.section.getBoundingClientRect().top) + imageContainer.offsetHeight / 2;

        if(window.innerWidth < 992) {
            backgroundHeight += imageContainer.getElementsByClassName('name-position-container')[0].offsetHeight/2;
        }
        this.sectionBackground.style.height = backgroundHeight +'px';
    }

    updatePrevNextButtonPosition() {
        console.log('BoxCarousel.updatePrevNextButtonPosition');
        let imageContainer = this.element.getElementsByClassName('image-container')[0];
        // let namePositionContainer = imageContainer.getElementsByClassName('name-position-container')[0];
        console.log('updatePrevNextButtonPosition:  this.imageContainer', imageContainer, imageContainer.clientHeight);

        let top = Math.round(imageContainer.clientHeight / 2);
        this.element.getElementsByClassName('flickity-prev-next-button')[0].style.top = top + 'px';
        this.element.getElementsByClassName('flickity-prev-next-button')[1].style.top = top + 'px';

    }

    onSliderReady() {
        console.log('BoxCarousel.onSliderReady', this.element);
        window.addEventListener('resize', this.onResize.bind(this));
        let that = this;
        setTimeout(function(){
            that.updateBackground();
            that.updatePrevNextButtonPosition();
        }, 100);
    }

    onResize() {
        console.log('BoxCarousel.onResize', this.element, this.element.offsetTop);
        this.updateBackground();
        this.updatePrevNextButtonPosition();
    }
}

BoxCarousel.elementClassName = 'box-carousel-base';
BoxCarousel.instances = [];
BoxCarousel.init = function () {
    console.log('BoxCarousel.init');
    var elements = document.getElementsByClassName(BoxCarousel.elementClassName);
    for (const element of Array.from(elements)) {
        BoxCarousel.instances.push(new BoxCarousel(element));
    }
    console.log('BoxCarousel.instances.length', BoxCarousel.instances.length);
};

BoxCarousel.onDispose = function () {
    console.log('BoxCarousel.onDispose');
    while (BoxCarousel.instances.length) {
        console.log('BoxCarousel.instances.length', BoxCarousel.instances.length);
        let instance = BoxCarousel.instances.pop();
        instance.destroy();
        instance = null;
    }
};

export default BoxCarousel;

if (module.hot) {
    module.hot.dispose(BoxCarousel.onDispose);
}
